import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { PLAY_STORE_URL } from "../data/aboutContent";

const APP_STORE_URL =
  "https://apps.apple.com/app/skutopia-academy/id6504804981";

export default function StoryLanding() {
  const { storyId } = useParams<{ storyId: string }>();

  const deepLink = useMemo(
    () =>
      storyId
        ? `skutopia://student-story/${encodeURIComponent(storyId)}`
        : "skutopia://",
    [storyId]
  );

  const isAndroid = useMemo(() => /Android/i.test(navigator.userAgent), []);
  const isIos = useMemo(
    () => /iPhone|iPad|iPod/i.test(navigator.userAgent),
    []
  );

  useEffect(() => {
    // Try opening in the native app first via deep link
    window.location.replace(deepLink);

    // Fallback: if the app didn't intercept, send to the appropriate store
    const timer = setTimeout(() => {
      if (isIos) {
        window.location.replace(APP_STORE_URL);
      } else if (isAndroid) {
        window.location.replace(PLAY_STORE_URL);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [deepLink, isAndroid, isIos]);

  const storeUrl = isIos ? APP_STORE_URL : PLAY_STORE_URL;
  const storeName = isIos ? "App Store" : "Google Play";

  return (
    <main className="grid min-h-screen place-items-center bg-[#044d35] px-6 text-center text-white">
      <div className="mx-auto max-w-lg">
        <p className="text-sm font-semibold uppercase tracking-wide text-white/70">
          Skutopia Academy
        </p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
          Someone shared a story with you
        </h1>
        <p className="mt-4 text-base text-white/85">
          Open the Skutopia Academy app to read the full story, react, and share
          your thoughts with the community.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <a
            href={deepLink}
            className="inline-flex items-center justify-center rounded-xl bg-white px-5 py-3 text-sm font-bold text-[#044d35]"
          >
            Open in app
          </a>
          <a
            href={storeUrl}
            className="inline-flex items-center justify-center rounded-xl border border-white/40 px-5 py-3 text-sm font-semibold text-white"
          >
            Get the app on {storeName}
          </a>
        </div>
      </div>
    </main>
  );
}
